<h2 mat-dialog-title>Detalle de la variedad</h2>

<div
  *ngIf="varietyDetailObs | async as varietyDetail"
  mat-dialog-content
  fxLayout="row"
  fxLayoutAlign="space-between start"
>
  <div fxFlex="78">
    <div *ngFor="let detail_variery of varietyDetail.data.variety_data">
      <div fxFlex="49">
        <p>
          <label style="font-weight: bold">
            {{ detail_variery.label }}
          </label>
        </p>
      </div>
      <div fxFlex="49">
        <p>
          <label style="font-style: italic">
            {{ detail_variery.value }}
          </label>
        </p>
      </div>
    </div>
  </div>

  <div fxFlex="20">
    <div *ngFor="let image_variery of varietyDetail.data.variety_images">
      <div fxFlex="100">
        <label style="font-weight: bold">
          {{ image_variery.label }}
        </label>
        <br />
        <img
          style="max-height: 200px; height: 100%; width: 100%"
          src="{{ image_variery.url }}"
        />
      </div>
    </div>
  </div>
</div>
<div *ngIf="!varietyDetailObs">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cerrar</button>
</mat-dialog-actions>
